import React, { useState } from 'react'
import Stars from './Stars';
import { getReviewScoreDesc } from '../../helpers/templateHelpers';
import { useTranslation } from 'react-i18next';


function  StarsQuestion({ id, index, value, onChange }) {

    const { t } = useTranslation();

    let answerable = value ? true : false;

    const roundValue = (value) => {
        if (!value) return undefined;
        return parseFloat(value.toFixed(1));
    }

    let roundedValue = roundValue(value);
    const [description, setDescription] = useState(getReviewScoreDesc(roundedValue,roundedValue));

    
    const handleHoverStars = (score) => {
        setDescription(getReviewScoreDesc(score,roundedValue));
    }

    return (<>
        <div>
            <Stars
                value={roundedValue}
                answerable={answerable}
                onMouseOver={handleHoverStars}
                onMouseLeave={handleHoverStars}
                onChange={(score) => onChange?.(id, score, index)}
            />
        </div>
        <p className="description text-center mainScore">{t(description)}</p>
    </>
    );
}

export default StarsQuestion